import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { ftpSubNav } from "@/lib/navigationItems";

export const Route = createFileRoute("/portal/ftp")({
  component: FtpLayout,
});

function FtpLayout() {
  return (
    <div className="space-y-4">
      <ProductSubNav items={ftpSubNav} />
      <Outlet />
    </div>
  );
}
